module.exports = __webpack_public_path__ + "static/huggingface-logo-hover-fc788123794bf89dd140fc0325b9f203.png";